import { RxJsonSchema } from 'rxdb';

export interface FeatureFlagDocument {
	id: string; // Always 'feature-flags' - singleton document
	flags: Record<string, boolean>;
	lastUpdated: string; // ISO timestamp
	version: number; // For conflict resolution
}

export const featureFlagSchema: RxJsonSchema<FeatureFlagDocument> = {
	version: 1,
	primaryKey: 'id',
	type: 'object',
	properties: {
		id: {
			type: 'string',
			maxLength: 50,
		},
		flags: {
			type: 'object',
			additionalProperties: {
				type: 'boolean',
			},
		},
		lastUpdated: {
			type: 'string',
			format: 'date-time',
		},
		version: {
			type: 'number',
			minimum: 0,
		},
	},
	required: ['id', 'flags', 'lastUpdated', 'version'],
};
